import '../select/gb-select.tag.html';
import { Sort } from './gb-sort';
riot.tag2('gb-sort', '<yield> <gb-select scope="gb-sort"> </gb-select> </yield>', '', '', function(opts) {
    this._mixin(Sort);
});



/** WEBPACK FOOTER **
 ** ./src/tags/sort/gb-sort.tag.html
 **/